import { useSelector } from "react-redux";
import { getTheme } from "./selector";


export function useAppTheme() {
  const selectedTheme=useSelector(getTheme);
  return {selectedTheme}
}
